import script from "./edit-cart-item-body.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-cart-item-body.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__